<template>
	<div class="scroll-container">
		<img style="height:200px ;width:400px ;" src="../../../assets/home/phenological/Budding .png" alt="">
		<div class="scroll-nav">
			<div class="scroll-text">
				<p>果实转色期，葡萄果实开始变色。这是糖分积累和风味形成的重要时期。需要保持适宜的温度和光照，避免过度的灌溉。			</p>
				<p>农事操作:(追肥：实进入转色期前 1 周，施用硫酸钾 20~25 kg/每亩；借滴灌施用高钾水溶肥 10~15kg/每亩， 3 次，间隔 10天 ；同时，叶面喷施 0.3% 磷酸二氢钾 3 次，间隔 10天 。
				副梢管理：顶端副梢留 4~6 叶摘心，其余副梢留 2 叶摘心。幼苗管理：距离主干 50cm ，四周根外追施氮、磷、钾含量均为17% 的复合肥 1kg/ 株。 按照树形要求， 整理绑缚延长枝，其他副梢留 2 叶摘心。))
				</p>
			</div>
		</div>
		<div class="scroll-nav1 scroll-nav">
			<div class="scroll-text scroll-text1">
				<p>果实转色期，葡萄果实开始变色。这是糖分积累和风味形成的重要时期。需要保持适宜的温度和光照，避免过度的灌溉。			</p>
				<p>农事操作:(追肥：实进入转色期前 1 周，施用硫酸钾 20~25 kg/每亩；借滴灌施用高钾水溶肥 10~15kg/每亩， 3 次，间隔 10天 ；同时，叶面喷施 0.3% 磷酸二氢钾 3 次，间隔 10天 。
				副梢管理：顶端副梢留 4~6 叶摘心，其余副梢留 2 叶摘心。幼苗管理：距离主干 50cm ，四周根外追施氮、磷、钾含量均为17% 的复合肥 1kg/ 株。 按照树形要求， 整理绑缚延长枝，其他副梢留 2 叶摘心。))
				</p>
			</div>
		</div>
	</div>
</template>

<style>
	.scroll-container {
		width: 100%;
		height: 280px;
		position: relative;

		img {
			text-indent: 0em;
			margin-left: 10px;
			
		}

		/* white-space: nowrap; */
	}

	.scroll-nav {
		width: 100%;
		height: 80px;
		overflow: hidden;
		position: absolute;
		bottom: 0;
		left: 0;

		.scroll-text {
			display: inline-block;
			animation: scroll 10s linear infinite;
			text-indent: 2em;
			/* Set first-line indentation */
		}

		.scroll-text1 {
			animation-delay: 5s;
		}
	}

	.scroll-nav1 {
		animation: opacitys 5s linear;
	}

	/* 定义动画关键帧 */
	@keyframes opacitys {
		0% {
			opacity: 0;
			/* 初始位置：左侧 */
		}
		
		99% {
			opacity: 0;
			/* 初始位置：左侧 */
		}

		100%  {
			opacity: 1;
			/* 终点位置：右侧 */
		}
	}

	@keyframes scroll {
		0% {
			transform: translatey(100%);
		}

		100% {
			transform: translatey(-100%);
		}
	}
</style>